<template>
    <el-dialog
            title="查看明细"
            :visible.sync="detailVisible"
            append-to-body
            width="65%"
            :before-close="handleClose"
        >
          <div slot="title" >
            <span>查看明细</span>
            <span class="dia-num">总包装数：{{ totalNum }}</span>
            <span class="dia-num">总方量(m³)：{{ totalAmount }}</span>
          </div>
            <el-table border :data="rowDtailData"  max-height="400"  v-loading="loading">
                <el-table-column
                    property="customerItemCode"
                    label="客户商品编码"
                    width="130"
                    sortable
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    property="itemName"
                    label="商品名称"
                    width="300"
                    sortable
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    property="totalPackageQuantity"
                    label="包装数"
                    sortable
                ></el-table-column>
                <el-table-column
                    property="planQty"
                    label="件数"
                    sortable
                ></el-table-column>
                <el-table-column
                    property="volume"
                    label="方量(m³)"
                    sortable
                ></el-table-column>
            </el-table>
        </el-dialog>
</template>
<script>
import { itemdeailCount } from '@/modules/transport/otp/api/visualMapLayout';
export default {
    props: {
        detailVisible: Boolean,
        detailList: Array
    },
    data () {
        return {
            totalAmount: 0,
            totalNum: 0,
            rowDtailData: [],
            loading: false
        };
    },
    watch: {
        detailVisible (val) {
            if (val) {
                this.loading = true;
                this.rowDtailData = [];
                this.itemdeailCount(this.detailList);
            }
        }
    },
    methods: {
        handleClose () {
            this.$emit('update:detailVisible', false);
        },

        itemdeailCount (data) {
            const params = data.map(v => v.taskNo);
            itemdeailCount(params).then(res => {
                if (res && +res.code === 0 && res.data) {
                    this.rowDtailData = res.data.list || [];
                    this.totalNum = this.rowDtailData.reduce((pre, cur) => { return pre + cur.totalPackageQuantity; }, 0) || 0;
                    this.totalAmount = this.rowDtailData.reduce((pre, cur) => { return pre + cur.volume; }, 0).toFixed(2);
                }
            }).finally(() => {
                this.loading = false;
            });
        }
    }
};
</script>
<style lang="less" scoped>
.dia-num {
    padding-left: 50px;
    font-size: 12px;
    color: #94979a;
}

::v-deep .el-table--border {
    border-left: none;
}
</style>
